import React from 'react';
import { CircularProgress } from 'material-ui';

const ProgressBarCenter = () => (
  <div
    id='progress-bar'
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <CircularProgress size={80} thickness={5} />
  </div>
);

export default ProgressBarCenter;



// WEBPACK FOOTER //
// ./src/components/ProgressBarCenter.js